// extracted by mini-css-extract-plugin
export var borderRadius = "_64-4";
export var large = "_64-3";
export var logoContainer = "_64-0";
export var nameLogo = "_64-2";
export var small = "_64-1";